import React, { useEffect, useRef, useState } from 'react';
import './asideNav.css';
import logo from '../../../../assets/images/Logo-no-bg.png';
import {
  Link,
  NavLink,
  Route,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import { LuLayoutDashboard } from 'react-icons/lu';
import { GrConfigure } from 'react-icons/gr';
import { FaChevronDown } from 'react-icons/fa';
import { FaDirections } from 'react-icons/fa';
import { MdDeliveryDining } from 'react-icons/md';
import { RiProhibitedLine } from 'react-icons/ri';
import { MdMergeType } from 'react-icons/md';
import { FaCity } from 'react-icons/fa6';
import { FaFlag } from 'react-icons/fa';
import { MdOutlineDisplaySettings } from 'react-icons/md';
import { HiUserGroup } from 'react-icons/hi2';
import { MdOutlineDevices } from 'react-icons/md';
import { RxDimensions } from 'react-icons/rx';
import { MdLocalOffer } from 'react-icons/md';
import { BiSolidOffer } from 'react-icons/bi';
import { LuPackagePlus } from 'react-icons/lu';
import { TbCategory2 } from 'react-icons/tb';
import { MdOutlineCategory } from 'react-icons/md';
import { IoIosBarcode } from 'react-icons/io';
import { FaSitemap } from 'react-icons/fa6';
import { IoPerson } from 'react-icons/io5';
import { FaMoneyBillWave } from 'react-icons/fa6';
import { FaBarcode } from 'react-icons/fa6';
import { LuPrinter } from 'react-icons/lu';
import { MdOutlinePayments } from 'react-icons/md';
import { MdCorporateFare } from 'react-icons/md';
import { HiOutlineReceiptTax } from 'react-icons/hi';
import { FaWeightHanging } from 'react-icons/fa6';
import { GrDeliver } from 'react-icons/gr';
import { IoScan } from 'react-icons/io5';
import { LuGitBranchPlus } from 'react-icons/lu';
import { GoIssueClosed } from 'react-icons/go';
import { MdOutlineContactMail } from 'react-icons/md';
import { MdOutlineHistory } from 'react-icons/md';
import formateText from '../../../../utils/Formate';
import { BsBox } from 'react-icons/bs';
import { RiLockPasswordLine } from 'react-icons/ri';
import { IoTicket } from 'react-icons/io5';
import { FaBoxOpen } from 'react-icons/fa';
import { FaTruck } from 'react-icons/fa6';
import { LuScanLine } from 'react-icons/lu';
import { AiOutlineEuro } from 'react-icons/ai';
import { FaCodeBranch } from 'react-icons/fa';
import { MdOutlinePriceChange } from 'react-icons/md';
import { TbRulerMeasure } from 'react-icons/tb';
import { AiOutlineStock } from 'react-icons/ai';
import { MdOutlinePayment } from 'react-icons/md';
import { MdOutlineAnalytics } from 'react-icons/md';
import { MdOutlineInsights } from 'react-icons/md';
import ToggleButton from '../../../sharedComponents/navbar/sub_component/ToggleButton';
import GetLocalStorageUserId from '../../../sharedComponents/GetLocalStorageuserId';
import { toast } from 'react-toastify';
import NotificationBell from '../../../sharedComponents/notifications/NotificationBell';
import SignalRConnectionPill from '../../../sharedComponents/notifications/SignalRConnectionPill';

const AsideNav = () => {
  const [showAside, setShowAside] = useState(false);
  const [toggleBtnChecked, setToggleBtnChecked] = useState(false);
  const ToggleEventHandler = (e) => {
    e.stopPropagation();
    setShowAside(e.target.checked);
    setToggleBtnChecked(e.target.checked);
  };
  const Routes = [
    {
      to: 'courier-current-stock',
      name: 'Courier Current stock',
      icon: <AiOutlineStock />,
    },
    {
      to: 'sub-branch',
      name: 'Sub-Branch',
      icon: <FaCodeBranch />,
    },
    {
      to: 'agent-transport',
      name: 'Agent Transport',
      icon: <FaTruck />,
    },
    {
      to: 'parcel-status',
      name: 'Parcel Status',
      icon: <FaBoxOpen />,
    },
    {
      to: 'route',
      name: 'Routes',
      icon: <FaDirections />,
    },
    {
      to: 'agent',
      name: 'Agent',
      icon: <IoPerson />,
    },
    {
      to: 'scanning-point',
      name: 'Scanning Point',
      icon: <IoScan />,
    },
    {
      to: 'city',
      name: 'City',
      icon: <FaCity />,
    },
    {
      to: 'country',
      name: 'Country',
      icon: <FaFlag />,
    },
    {
      to: 'aditional-cost',
      name: 'Additional cost',
      icon: <FaMoneyBillWave />,
    },
    // {
    //   to: "barcode",
    //   name: "Barcode",
    //   icon: <FaBarcode />,
    // },
    // {
    //   to: "barcode-details",
    //   name: "Barcode details",
    //   icon: <IoIosBarcode />,
    // },

    {
      to: 'prohibited-item',
      name: 'Prohibited item',
      icon: <RiProhibitedLine />,
    },
    {
      to: 'shiping',
      name: 'Shiping service',
      icon: <MdDeliveryDining />,
    },
    {
      to: 'cargo-type',
      name: 'Cargo types',
      icon: <MdMergeType />,
    },
    // {
    //   to: "company",
    //   name: "Company",
    //   icon: <MdCorporateFare />,
    // },
    {
      to: 'pickup',
      name: 'Pickup',
      icon: <GrDeliver />,
    },
    {
      to: 'measurement-unit',
      name: 'Measurement unit',
      icon: <TbRulerMeasure />,
    },
    {
      to: 'weight',
      name: 'Weight',
      icon: <FaWeightHanging />,
    },
    {
      to: 'vat-configuration',
      name: 'Vat configuration',
      icon: <HiOutlineReceiptTax />,
    },

    // {
    //   to: "departmental-operation",
    //   name: "Def. operation",
    //   icon: <MdOutlineDisplaySettings />,
    // },
    // {
    //   to: "department",
    //   name: "Department",
    //   icon: <HiUserGroup />,
    // },
    {
      to: 'device',
      name: 'Device',
      icon: <MdOutlineDevices />,
    },
    {
      to: 'dimension',
      name: 'Dimension',
      icon: <RxDimensions />,
    },
    // {
    //   to: "offer",
    //   name: "Discounted offer",
    //   icon: <MdLocalOffer />,
    // },
    // {
    //   to: "offer-details",
    //   name: "Discounted offer details",
    //   icon: <BiSolidOffer />,
    // },
    {
      to: 'extra-packaging',
      name: 'Extra packaging',
      icon: <LuPackagePlus />,
    },
    {
      to: 'item-category',
      name: 'Item category',
      icon: <MdOutlineCategory />,
    },
    // {
    //   to: "function",
    //   name: "Function",
    //   icon: <TbCategory2 />,
    // },
    {
      to: 'item-type',
      name: 'Item type',
      icon: <FaSitemap />,
    },
    {
      to: 'branch',
      name: 'Branch',
      icon: <LuGitBranchPlus />,
    },
  ];

  Routes?.sort((a, b) => {
    if (a.name > b.name) return 1;
    if (a.name < b.name) return -1;
    return 0;
  });

  const [dropDown, setDropDown] = useState(false);
  const [settingsDropDown, setSettingsDropDown] = useState(false);

  const url = useLocation();

  useEffect(() => {
    if (url.pathname.includes('setup/')) {
      setDropDown(true);
    } else {
      setDropDown(false);
    }

    if (url.pathname.includes('settings/')) {
      setSettingsDropDown(true);
    } else {
      setSettingsDropDown(false);
    }
  }, [url]);

  // route change handle.

  const NavBarhandle = () => {
    console.log('fired.');
    setToggleBtnChecked(false);
    setShowAside(false);
  };
  const move = useNavigate();
  const logoutHandle = () => {
    toast.success('Logout Successfull', {
      position: 'top-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'colored',
    });
    localStorage.removeItem('sundorbonBookingUserDetails');
    localStorage.removeItem('token');
    move('/');
  };

  const parentRoutes = (
    <>
      <NavLink
        onClick={NavBarhandle}
        end
        className='flex items-center lg:hover:bg-[#747474] duration-100 hover:rounded-xl lg:py-3 pl-3 gap-3'
        to={'/admin-dashboard'}
      >
        <LuLayoutDashboard />
        Dashboard
      </NavLink>
      <NavLink
        onClick={NavBarhandle}
        className='flex items-center lg:hover:bg-[#747474] duration-100 hover:rounded-xl lg:py-3 pl-3 gap-3'
        to={'analytics'}
      >
        <MdOutlineInsights />
        Analytics
      </NavLink>
      <button
        onClick={() => setDropDown((prev) => !prev)}
        className={`flex justify-between pr-2  items-center w-full lg:hover:bg-[#747474] ${
          dropDown || url.pathname.includes('setup/')
            ? 'lg:bg-[#747474] rounded-xl text-white'
            : 'bg-transparent'
        } duration-100 hover:rounded-xl lg:py-3 pl-3 gap-16`}
      >
        <span className='flex items-center gap-3'>
          <GrConfigure /> Set-up
        </span>{' '}
        <FaChevronDown
          className={`${dropDown ? 'rotate-180' : ''} duration-300`}
        />
      </button>
      <ul
        className={` lg:pl-6 text-sm w-full ${
          dropDown ? 'block' : 'hidden'
        } duration-200`}
      >
        {Routes?.map((item, idx) => {
          return (
            <NavLink
              onClick={NavBarhandle}
              key={idx}
              className='flex items-center mt-1 lg:hover:bg-[#747474] duration-100 hover:rounded-xl lg:py-3 pl-3 gap-3 text-lg'
              to={'setup/' + item.to}
            >
              {item.icon}
              {formateText(item.name)}
            </NavLink>
          );
        })}
      </ul>
      <NavLink
        onClick={NavBarhandle}
        end
        className='flex w-full  items-center lg:hover:bg-[#747474] duration-100 hover:rounded-xl lg:py-3 pl-3 gap-3'
        to={'issue'}
      >
        <GoIssueClosed />
        Issue
      </NavLink>
      <NavLink
        onClick={NavBarhandle}
        end
        className='flex w-full items-center lg:hover:bg-[#747474] duration-100 hover:rounded-xl lg:py-3 pl-3 gap-3'
        to={'inquiry'}
      >
        <MdOutlineContactMail />
        Inquiry
      </NavLink>
      <NavLink
        onClick={NavBarhandle}
        end
        className='flex w-full items-center lg:hover:bg-[#747474] duration-100 hover:rounded-xl lg:py-3 pl-3 gap-3'
        to={'bookings'}
      >
        <MdOutlineHistory />
        Bookings
      </NavLink>
      {/* <NavLink
        end
        className="flex items-center hover:bg-[#747474] duration-100 hover:rounded-xl lg:py-3 pl-3 gap-3"
        to={"pay"}
      >
        <MdOutlinePayment />
        Pay
      </NavLink> */}
      <NavLink
        onClick={NavBarhandle}
        end
        className='flex items-center lg:hover:bg-[#747474] duration-100 hover:rounded-xl lg:py-3 pl-3 gap-3'
        to={'payment'}
      >
        <MdOutlinePayments />
        Payment
      </NavLink>

      {/* Settings dropdown */}
      <button
        onClick={() => setSettingsDropDown((prev) => !prev)}
        className={`flex justify-between pr-2 items-center w-full lg:hover:bg-[#747474] ${
          settingsDropDown || url.pathname.includes('settings/')
            ? 'lg:bg-[#747474] rounded-xl text-white'
            : 'bg-transparent'
        } duration-100 hover:rounded-xl lg:py-3 pl-3 gap-16`}
      >
        <span className='flex items-center gap-3'>
          <MdOutlineAnalytics /> Settings
        </span>
        <FaChevronDown
          className={`${settingsDropDown ? 'rotate-180' : ''} duration-300`}
        />
      </button>
      <ul
        className={`lg:pl-6 text-sm w-full ${
          settingsDropDown ? 'block' : 'hidden'
        } duration-200`}
      >
        <NavLink
          onClick={NavBarhandle}
          className='flex items-center mt-1 lg:hover:bg-[#747474] duration-100 hover:rounded-xl lg:py-3 pl-3 gap-3 text-lg'
          to={'settings/tracking-integration'}
        >
          <MdOutlineAnalytics />
          Tracking / Integration
        </NavLink>
      </ul>

      <NavLink
        onClick={NavBarhandle}
        className='flex items-center lg:hover:bg-[#747474] duration-100 hover:rounded-xl lg:py-3 pl-3 gap-3'
        to={'agent-box-ssign'}
      >
        <BsBox />
        Agent Box Assign
      </NavLink>

      <NavLink
        onClick={NavBarhandle}
        className='flex items-center lg:hover:bg-[#747474] duration-100 hover:rounded-xl lg:py-3 pl-3 gap-3'
        to={'parcel-status-scan'}
      >
        <LuScanLine />
        Parcel Status Scan
      </NavLink>
      <NavLink
        onClick={NavBarhandle}
        className='flex items-center lg:hover:bg-[#747474] duration-100 hover:rounded-xl lg:py-3 pl-3 gap-3'
        to={'parcel-setup-cost'}
      >
        <MdOutlinePriceChange />
        Parcel Setup Cost
      </NavLink>

      <NavLink
        onClick={NavBarhandle}
        className='flex items-center lg:hover:bg-[#747474] duration-100 hover:rounded-xl lg:py-3 pl-3 gap-3'
        to={'transport-agent-assigning'}
      >
        <AiOutlineEuro />
        Transport Agent Assigning
      </NavLink>

      {/* <NavLink
        className="flex items-center hover:bg-[#747474] duration-100 hover:rounded-xl lg:py-3 pl-3 gap-3"
        to={"change-password"}
      >
        <RiLockPasswordLine />
        Change Password
      </NavLink> */}

      <NavLink
        onClick={NavBarhandle}
        className='flex items-center lg:hover:bg-[#747474] duration-100 hover:rounded-xl lg:py-3 pl-3 gap-3'
        to={'print-box-serial-barcode'}
      >
        <FaBarcode />
        Print Box Serial Barcode
      </NavLink>

      <NavLink
        onClick={NavBarhandle}
        className='flex  items-center lg:hover:bg-[#747474] duration-100 hover:rounded-xl lg:py-3 pl-3 gap-3'
        to={'print-barcode'}
      >
        <LuPrinter />
        Print Barcode
      </NavLink>
      <Link
        className='flex lg:w-full items-center lg:hover:bg-[#747474] duration-100 hover:rounded-xl lg:py-3 pl-3 gap-3'
        to={'/admin-bookings'}
      >
        <IoTicket />
        Add Booking
      </Link>
    </>
  );

  // get local storage data.
  const localdata = localStorage.getItem('sundorbonBookingUserDetails');
  const Name = JSON.parse(localdata)?.Name || '';
  const Email = JSON.parse(localdata)?.Email || '';

  return (
    <div className='xl:w-[17%] lg:w-[25%] lg:flex z-30 flex-col justify-start items-start lg:gap-12 lg:pb-11 overflow-hidden lg:overflow-visible lg:pt-11 w-full lg:h-[93vh] lg:rounded-[25px] lg:sticky top-0 lg:top-[3%] lg:left-2 xl:left-5 bg-black text-white lg:bg-[#b4b4b4]'>
      <img
        // className="w-full px-3 object-contain  lg:inline-block hidden xl:h-[142px] lg:h-[100px] "
        className='w-full max-w-[220px]  object-contain mx-auto px-3 lg:inline-block hidden xl:h-[142px] lg:h-[100px]'
        src={logo}
        alt='logo'
      />
      <div className='w-full hidden lg:block px-3'>
        <div className='flex items-center justify-between gap-2 mb-3'>
          <div className='min-w-0 flex-1 text-center'>
            <h1 className='text-xl font-semibold truncate'>{Name}</h1>
            <h1 className='text-sm font-medium mt-1 truncate text-white/90'>
              {Email}
            </h1>
          </div>
          <div className='flex flex-col items-end gap-1.5 shrink-0'>
            <NotificationBell variant='dark' />
            <SignalRConnectionPill compact />
          </div>
        </div>
      </div>
      {/* aside bar from lg screen. */}
      <ul className='w-full  hidden scrollbar lg:h-[81%] lg:overflow-y-auto lg:pr-5 lg:pl-3 lg:flex flex-col gap-y-1 xl:text-xl text-lg text-white'>
        {parentRoutes}
      </ul>
      {/* aside bar for mobile screen. */}

      <div className=' lg:hidden block z-50 text-white  w-full  '>
        <div className='relative z-50 flex items-center justify-between gap-2 pr-2 pl-2 bg-[#424242]'>
          <ToggleButton
            value={toggleBtnChecked}
            showAside={showAside}
            eventHandle={ToggleEventHandler}
          />

          <div className='flex items-center gap-2'>
            {GetLocalStorageUserId() ? (
              <>
                <SignalRConnectionPill compact />
                <NotificationBell variant='dark' />
              </>
            ) : null}
            {GetLocalStorageUserId() ? (
              <button type='button' onClick={logoutHandle} className='text-sm'>
                Logout
              </button>
            ) : (
              <Link to={'/login'}>Login</Link>
            )}
          </div>

          {/* <button className="">
            <Link to={"/login"}>Login</Link>
          </button> */}
        </div>

        <div
          className={`w-full bg-[#424242]   duration-300  absolute  z-40 ${
            showAside ? 'translate-y-0' : '-translate-y-[2000px]'
          }`}
        >
          <ul className='flex flex-col pb-4 gap-y-3 justify-center text-[20px] font-normal items-start pl-[40px]'>
            {parentRoutes}
          </ul>
        </div>
      </div>
    </div>
  );
};

export default AsideNav;
